import Card from "../components/Card"
import BankIcon from "../assets/BankIcon.svg"
import AddIcon from "../components/Svg/AddIcon"
import ValidateBankModal from "./ValidateBankModal"
import BankDetails from "../pages/BankDetails"
import { useState } from "react"
import { useParams } from "react-router-dom"
import { useEffect } from "react"


function BankSettings() {
  const [validateBankModal, setvalidateBankModal] = useState(false);
  const [bankDetails, setBankDetails] = useState(false)
  const { token } = useParams()

  const getBankDetails = async (token) => {
   const getOptions = {
      method: 'GET',
      headers: {
        "Content-Type" : "application/json",
        "Accept": "application/json",
        "Authorization": `Bearer ${token}`
       }
    };
    await fetch (`${process.env.REACT_APP_API_URL}/bank/get`, getOptions)
    .then (response => response.json())
    .then (data => {
      if(data.bank_details){
        setBankDetails(true)
      }
    })
    .catch(err => console.log(err))
  }

  useEffect(() => {
    getBankDetails(token)
  },[token])

  return (
    <>
   <div className="bank-container">
     {bankDetails ? <BankDetails onClick={() => setvalidateBankModal(true)}/> : 
     <>
     <h5 className='bc-head'>Bank Information</h5>
     <Card>
        <div className="bs-content">
        <img className="bank-icon" src={BankIcon} alt="bank-icon" />
        <h6>Add a Bank account to receive your withdrawals</h6>
        <p>Click on the button below to add new bank account.</p>
        <div className="bc-btn-group" onClick={() => setvalidateBankModal(true)}>
          <AddIcon fill='white'/>
          Add Bank Account
        </div>
        </div>
     </Card>
     </>

     }
       <div className={bankDetails ? "bc-btn-group bd-btn-group" : "d-none"}>
          <AddIcon fill='white'/>
          Add Bank Account
        </div>
   </div>

   <ValidateBankModal show={validateBankModal}
        onHide={() => setvalidateBankModal(false)}  ></ValidateBankModal>
   </>
  )
}

export default BankSettings